module.exports = __webpack_public_path__ + "img/10.2554ccb6.jpg";